import React, {useEffect} from 'react';
import {faBolt} from '@fortawesome/pro-solid-svg-icons';
import {useForm} from '@netx/core-components/Form';
import {
	LegacyFormDialog as FormDialog,
	type LegacyFormDialogProps as FormDialogProps,
	type LegacyExtendFormDialogProps,
} from '@netx/core-components/FormDialog';
import {styled} from '@netx/core-components/Theme';
import {customActionDefaults} from '../../defaults';
import {CUSTOM_ACTION_ACTION_LABEL, CUSTOM_ACTION_TITLE} from '../../locales';
import type {CustomActionFormData} from '../../types';
import {CustomActionEdit, CustomActionEditProps} from './CustomActionEdit';

const CustomActionEditDialogRoot = styled(FormDialog)(({theme}) => ({
	form: {
		padding: 0,
	},
})) as unknown as (
	props: FormDialogProps<true, CustomActionFormData>,
) => JSX.Element;

export type CustomActionEditDialogProps = Omit<
	CustomActionEditProps,
	'form' | 'onSubmit'
> &
	Omit<LegacyExtendFormDialogProps<true, CustomActionFormData>, 'form'>;

export const CustomActionEditDialogPrimitive = ({
	open,
	customAction,
	onClose,
	onSubmit,
	DialogProps,
	...props
}: CustomActionEditDialogProps) => {
	const form = useForm<CustomActionFormData>(customActionDefaults, {
		removeValueOnUnregister: false,
	});

	useEffect(() => {
		form.reset({
			...customActionDefaults,
			...customAction,
		});
	}, [customAction]);

	return (
		<CustomActionEditDialogRoot
			disableContentPadding
			form={form}
			icon={faBolt}
			isValid={form.isValid}
			open={open}
			requiresChanges
			title={CUSTOM_ACTION_TITLE.CUSTOM_ACTION}
			secondaryTitle={
				customAction?.id
					? CUSTOM_ACTION_TITLE.EDIT_CUSTOM_ACTION
					: CUSTOM_ACTION_TITLE.CREATE_CUSTOM_ACTION
			}
			onClose={onClose}
			onSubmit={onSubmit}
			confirmLabel={
				customAction?.id
					? CUSTOM_ACTION_ACTION_LABEL.SAVE
					: CUSTOM_ACTION_ACTION_LABEL.CREATE
			}
			{...DialogProps}
		>
			<CustomActionEdit {...props} form={form} customAction={customAction} />
		</CustomActionEditDialogRoot>
	);
};

export const CustomActionEditDialog = CustomActionEditDialogPrimitive;

export default CustomActionEditDialog;
